import type { CSSProperties, ReactNode } from "react";

type RuntimeFlagGeometryAttributes = { style: CSSProperties };

interface RuntimeFlagGeometryProps {
  fallback?: boolean;
  size: number;
  children: (attributes: RuntimeFlagGeometryAttributes) => ReactNode;
}

/** Applies caller-sized flag geometry while preserving the flag artwork's fixed 4:3 ratio. */
export function RuntimeFlagGeometry({ fallback, size, children }: RuntimeFlagGeometryProps): ReactNode {
  return children({
    style: {
      width: size,
      height: size * 0.75,
      fontSize: fallback ? Math.max(7, size * 0.34) : undefined,
      lineHeight: fallback ? 1 : undefined,
    },
  });
}
